import clsx from 'clsx';

interface Props {
  error: boolean;
}
export const PasswordRequirements = ({ error }: Props) => (
  <div className="my-4 p-1">
    <p className={clsx({ 'text-primary': !error, 'text-error': error })}>
      Passwords must contain:
    </p>
    <div className="flex flex-grow items-center justify-evenly gap-6">
      <ul className="list-disc">
        <li>One letter</li>
        <li>Eight characters</li>
      </ul>
      <ul className="list-disc">
        <li>One number</li>
        <li>One special character</li>
      </ul>
    </div>
  </div>
);
